class CharmGallery {
  constructor() {
    this.selectedCharms = [];
    this.init();
  }

  init() {
    this.setupCategoryTabs();
    this.setupCharmSelection();
    this.setupStackBuilder();
    this.setupLearnMoreButtons();
  }

  setupCategoryTabs() {
    const categoryTabs = document.querySelectorAll('.category-tab');
    const charmCards = document.querySelectorAll('.charm-card');

    categoryTabs.forEach(tab => {
      tab.addEventListener('click', () => {
        // Remove active class from all tabs
        categoryTabs.forEach(t => t.classList.remove('active'));
        // Add active class to clicked tab
        tab.classList.add('active');

        const category = tab.dataset.category;

        // Show/hide charm cards based on category
        charmCards.forEach(card => {
          if (category === 'all' || card.dataset.category === category) {
            card.style.display = 'block';
            card.style.animation = 'fadeInUp 0.6s ease forwards';
          } else {
            card.style.display = 'none';
          }
        });
      });
    });
  }

  setupCharmSelection() {
    const charmSelectButtons = document.querySelectorAll('.charm-select');

    charmSelectButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const charmCard = button.closest('.charm-card');
        const charmName = charmCard.querySelector('.charm-name').textContent;
        const charmId = charmCard.dataset.charm;

        // Check if charm is already selected
        if (this.selectedCharms.find(charm => charm.id === charmId)) {
          this.showNotification('This charm is already in your stack!', 'warning');
          return;
        }

        // Add charm to selected list
        this.selectedCharms.push({
          id: charmId,
          name: charmName,
          element: charmCard
        });

        // Update stack builder display
        this.updateStackBuilder();
        this.showNotification(`${charmName} added to your stack!`, 'success');

        // Add visual feedback to the charm card
        charmCard.style.transform = 'scale(1.05)';
        setTimeout(() => {
          charmCard.style.transform = '';
        }, 200);
      });
    });
  }

  setupStackBuilder() {
    const saveStackBtn = document.getElementById('save-stack');
    const clearStackBtn = document.getElementById('clear-stack');

    if (saveStackBtn) {
      saveStackBtn.addEventListener('click', () => {
        if (this.selectedCharms.length === 0) {
          this.showNotification('Please select some charms first!', 'warning');
          return;
        }

        // Save stack to localStorage
        localStorage.setItem('jamJewelsStack', JSON.stringify(this.selectedCharms));
        this.showNotification('Your stack has been saved!', 'success');
      });
    }

    if (clearStackBtn) {
      clearStackBtn.addEventListener('click', () => {
        this.selectedCharms = [];
        this.updateStackBuilder();
        this.showNotification('Stack cleared!', 'info');
      });
    }

    // Load saved stack on page load
    this.loadSavedStack();
  }

  setupLearnMoreButtons() {
    const learnMoreButtons = document.querySelectorAll('.charm-learn-more');

    learnMoreButtons.forEach(button => {
      button.addEventListener('click', (e) => {
        e.preventDefault();
        const charmCard = button.closest('.charm-card');
        const charmName = charmCard.querySelector('.charm-name').textContent;
        const charmStory = charmCard.querySelector('.charm-story p').textContent;

        // Create modal or expand story
        this.showCharmDetails(charmName, charmStory);
      });
    });
  }

  updateStackBuilder() {
    const selectedCharmsContainer = document.getElementById('selected-charms');
    
    if (this.selectedCharms.length === 0) {
      selectedCharmsContainer.innerHTML = '<p class="no-charms-message">Click on charms above to build your stack</p>';
      return;
    }

    selectedCharmsContainer.innerHTML = '';

    this.selectedCharms.forEach((charm, index) => {
      const charmElement = document.createElement('div');
      charmElement.className = 'selected-charm';
      charmElement.innerHTML = `
        <span>${charm.name}</span>
        <button class="remove-charm" data-index="${index}">×</button>
      `;

      // Add remove functionality
      const removeBtn = charmElement.querySelector('.remove-charm');
      removeBtn.addEventListener('click', () => {
        this.removeCharm(index);
      });

      selectedCharmsContainer.appendChild(charmElement);
    });
  }

  removeCharm(index) {
    const removedCharm = this.selectedCharms[index];
    this.selectedCharms.splice(index, 1);
    this.updateStackBuilder();
    this.showNotification(`${removedCharm.name} removed from your stack`, 'info');
  }

  loadSavedStack() {
    const savedStack = localStorage.getItem('jamJewelsStack');
    if (savedStack) {
      try {
        this.selectedCharms = JSON.parse(savedStack);
        this.updateStackBuilder();
      } catch (e) {
        console.log('Could not load saved stack');
      }
    }
  }

  showCharmDetails(name, story) {
    // Create a simple modal or expand the story
    const modal = document.createElement('div');
    modal.style.cssText = `
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      background: rgba(0, 0, 0, 0.8);
      display: flex;
      align-items: center;
      justify-content: center;
      z-index: 10000;
      animation: fadeIn 0.3s ease;
    `;

    modal.innerHTML = `
      <div style="
        background: white;
        padding: 2rem;
        border-radius: var(--border-radius-luxe);
        max-width: 500px;
        margin: 1rem;
        box-shadow: var(--shadow-luxe);
        animation: slideIn 0.3s ease;
      ">
        <h3 style="
          font-family: var(--font-display);
          color: var(--luxe-charcoal);
          margin-bottom: 1rem;
          text-align: center;
        ">${name}</h3>
        <p style="
          font-family: var(--font-body);
          color: var(--luxe-charcoal);
          line-height: 1.6;
          margin-bottom: 2rem;
        ">${story}</p>
        <button onclick="this.closest('.modal').remove()" style="
          background: var(--jam-gold);
          color: white;
          border: none;
          padding: 0.75rem 1.5rem;
          border-radius: var(--border-radius-luxe);
          cursor: pointer;
          font-family: var(--font-body);
          font-weight: 600;
          width: 100%;
        ">Close</button>
      </div>
    `;

    modal.className = 'modal';
    document.body.appendChild(modal);

    // Close modal when clicking outside
    modal.addEventListener('click', (e) => {
      if (e.target === modal) {
        modal.remove();
      }
    });
  }

  showNotification(message, type = 'info') {
    const notification = document.createElement('div');
    notification.style.cssText = `
      position: fixed;
      top: 20px;
      right: 20px;
      background: ${type === 'success' ? 'var(--jam-gold)' : type === 'warning' ? '#ff6b6b' : '#4ecdc4'};
      color: white;
      padding: 1rem 1.5rem;
      border-radius: var(--border-radius-luxe);
      box-shadow: var(--shadow-luxe);
      z-index: 10001;
      font-family: var(--font-body);
      font-weight: 600;
      animation: slideInRight 0.3s ease;
    `;

    notification.textContent = message;
    document.body.appendChild(notification);

    setTimeout(() => {
      notification.style.animation = 'slideOutRight 0.3s ease';
      setTimeout(() => {
        notification.remove();
      }, 300);
    }, 3000);
  }
}

// Initialize when DOM is loaded
document.addEventListener('DOMContentLoaded', () => {
  new CharmGallery();
});

// Add CSS animations
const style = document.createElement('style');
style.textContent = `
  @keyframes fadeIn {
    from { opacity: 0; }
    to { opacity: 1; }
  }
  
  @keyframes slideInRight {
    from { transform: translateX(100%); opacity: 0; }
    to { transform: translateX(0); opacity: 1; }
  }
  
  @keyframes slideOutRight {
    from { transform: translateX(0); opacity: 1; }
    to { transform: translateX(100%); opacity: 0; }
  }
`;
document.head.appendChild(style);
